<template>
  <div>
    <select-base
      v-model="value"
      class="municipio-select"
      :name="'municipio'"
      :class="[!label ? 'remove-label' : '', inputSelect]"
      :disabled="disabled"
      :require="require_"
      :invalido="invalido"
      :multiple="multiple"
      :label-select="'nome'"
      :carregar="carregarMunicipios"
      @input="enviarParaPai"
    />
  </div>
</template>

<style lang="scss">
.remove-label .form-group {
  margin-bottom: 0;
}

.municipio-select {
  min-width: 6rem !important;
}
</style>
<script>
import api from './api'
import '@core/scss/vue/libs/vue-select.scss'

export default {
  name: 'EstadosSelect',
  components: {
    SelectBase: () => import('@/shared/components/select-base/SelectBase.vue'),
  },
  props: {
    label: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    invalido: {
      type: Boolean,
      default: false,
    },
    require: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      default: () => { },
    },
    except: {
      type: Array,
      default: () => [],
    },
    inputSelect: {
      type: String,
      default: '',
    },
    externo: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      filtros: [
        {
          coluna: 'Nome',
          valor: '',
        },
      ],
    }
  },
  computed: {
    require_: {
      get() {
        return this.require
      },
    },
    exceptIds: {
      get() {
        return this.except.map(map => map.id)
      },
    },
  },
  methods: {
    carregarMunicipios(filtros) {
      return new Promise((resolve, reject) => {
        api.getMunicipiosResumidos(filtros, this.externo)
          .then(payload => {
            if (this.except && this.except.length > 0) {
              resolve({ data: payload.data.filter(filter => !this.exceptIds.includes(filter.id)) })
            } else {
              resolve(payload)
            }
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    enviarParaPai() {
      this.$emit('input', this.value)
    },
  },
}
</script>
